import * as TemplateActions from './template.actions';

export { TemplateActions };
